import { Flex } from "antd";
import { forwardRef } from "react";
import { Point, UserRole } from "tm-shared/types";

import { useAppSelector } from "@/hooks/redux";
import { selectUncompletedTasks } from "@/store/slices/progress";

import { PointInfo } from "../PointInfo";
import { StyledMHWrapper } from "./Styled";

interface PointHeaderViewProps extends React.HTMLAttributes<HTMLDivElement> {
    item: Point;
}

export const PointHeaderView = forwardRef<HTMLDivElement, PointHeaderViewProps>(
    ({ item: point, ...rest }, ref) => {
        const { role } = useAppSelector((s) => s.user);
        const uncompletedTasks = useAppSelector(selectUncompletedTasks);

        const hasDebt = role !== UserRole.Md && point?.hasDebt;

        return (
            <StyledMHWrapper
                $hasDebt={hasDebt}
                $hasUncompletedTask={uncompletedTasks?.some(
                    (task) => task.targetId === point.id,
                )}
                {...rest}
                ref={ref}
            >
                <Flex gap="12px" justify="flex-start" align="center">
                    <Flex vertical align="flex-start" justify="center">
                        <PointInfo point={point} />
                    </Flex>
                </Flex>
            </StyledMHWrapper>
        );
    },
);

PointHeaderView.displayName = "PointHeaderView";
